export default "__VITE_ASSET__BKBr_Gb$__"